import moment from "moment";
import { IBasicFilter } from "../../../../../../utils/common-type";
import {
  filterEmptyFiled,
  formatOrder,
  formatTimeFilter,
  getCurrentTimeZone,
  pageSizeList,
} from "../../../../../../utils/helper";

export interface IAccess {
  ip: string;
  clubID: string;
  enterTime: string;
  exitTime: string;
}

export interface IFilter extends IBasicFilter {
  clubID: string[];
  time: moment.Moment[];
  zone: string;
}

export interface ISearchProps {
  filter: IFilter;
  setFilter: React.Dispatch<React.SetStateAction<IFilter>>;
  downloadData: IAccess[];
}

export const sortableColumns = ["enterTime", "exitTime"];

export const buildFilter = (filter: IFilter) => {
  const params: any = {
    clubID: filter.clubID.join(),
    startTime: formatTimeFilter(filter.time[0], filter.zone),
    endTime: formatTimeFilter(filter.time[1], filter.zone),
    page: filter.pages,
    pageSize: filter.pageSize,
    order: formatOrder(filter.order, filter.orderBy),
  };

  return filterEmptyFiled(params);
};

export const defaultFilter: () => IFilter = () => ({
  clubID: [],
  time: [moment().startOf("days"), moment().endOf("days")],
  pages: 0,
  pageSize: Number(localStorage.getItem("pageSize")) || pageSizeList[0],
  order: undefined,
  orderBy: undefined,
  zone: getCurrentTimeZone(),
});
